import * as yup from 'yup';

import { emailValidationSchema } from 'src/constants/validation';

const userValidationSchema = yup.object({
  email: emailValidationSchema.required('Email field is required'),
  isAdmin: yup.boolean().defined(),
  locations: yup.array().nullable(),
});

export const employerStaffInviteValidationSchema = yup.object({
  users: yup.array().of(userValidationSchema),
});
